import { useState } from "react";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { usePRD5010_R01Store } from "./Store_PRD5010_R01";
import { CompanyDto } from "src/dtos/company/companyDto";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { blueButtonClass, grayButtonClass } from "src/components/common/common";

interface SearchSection_PRD5010_R01Props {
    onKpiSendClick: () => void;
}

export const SearchSection_PRD5010_R01 = ({ onKpiSendClick }: SearchSection_PRD5010_R01Props) => {
    const { PRD5010_R01Filter, setPRD5010_R01Filter } = usePRD5010_R01Store();
    const { compCdList, kpiKeyList } = useCommonCodeStore();


    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	
	const buttonClassName = (isDisabled?: boolean) => 
		`h-[24px] text-white rounded-[4px] px-[16px] font-semibold ${
			isDisabled 
				? grayButtonClass
				: blueButtonClass
		}`;

    return (
        <SearchSectionForm>
            <SearchDropDownForm<CompanyDto>
                label="사업장"
                value={PRD5010_R01Filter.compCd}
                optionList={compCdList}
                onChangeValue={v => setPRD5010_R01Filter({ compCd: v === 'all' ? '' : v })}
            />
            <SearchDateRangeForm
                label="조회기간"
                visible={pickerVisible}
                setVisible={setPickerVisible}
                dateRange={PRD5010_R01Filter.ocrdttmDateRange}
                setDateRange={v => setPRD5010_R01Filter({ ocrdttmDateRange: v })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />
            <SearchDropDownForm<SysCodeDto>
                label="KPI구분"
                value={PRD5010_R01Filter.kpifldcd}
                optionList={kpiKeyList}
                onChangeValue={v => setPRD5010_R01Filter({ kpifldcd: v === 'all' ? '' : v })}
            />
			{/* <button
				type="button"
				className={buttonClassName(false)}
				onClick={onKpiSendClick}
			>
				KPI 전송
			</button> */}
        </SearchSectionForm>
    );
};
